<template>
    <div
        class="relative mr-2 h-full rounded border border-t-0 border-neutral-10 bg-white drop-shadow-md"
    >
        <div
            class="block h-2 w-full rounded-tl rounded-tr bg-gradient-to-r from-neutral-20 to-primary-lighter"
        ></div>

        <div class="relative flex h-full flex-col pb-4">
            <div
                class="mb-4 mt-8 flex-none text-center text-[24px] font-normal"
            >
                <value-as-currency
                    value="subscriptionPlan.price_usd"
                    :value-in-cents="true"
                ></value-as-currency>
            </div>

            <div
                class="mb-4 flex-none text-center text-[16px] font-semibold uppercase text-neutral-60"
            >
                per {{ subscriptionPlan.period_label_singular }}
            </div>

            <div
                v-if="subscriptionPlan.cta_sticker"
                class="static right-4 top-3 m-auto h-4 w-auto md:right-0 md:w-full lg:right-3 xl:absolute xl:w-auto"
            >
                <svg
                    v-if="subscriptionPlan.cta_sticker === 'most_popular'"
                    class="m-auto"
                    fill="none"
                    height="20"
                    viewBox="0 0 97 20"
                    width="97"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect
                        fill="white"
                        height="16.1656"
                        rx="3"
                        stroke="url(#paint0_linear)"
                        stroke-width="2"
                        width="95"
                        x="1"
                        y="1.93604"
                    />
                    <path
                        d="M9.71733 6.74607V14.0188H10.9815V9.0117H11.049L13.0589 13.9975H14.0036L16.0135 9.02235H16.081V14.0188H17.3452V6.74607H15.733L13.5739 12.016H13.4886L11.3295 6.74607H9.71733ZM25.2784 10.3824C25.2784 8.03158 23.8438 6.64664 21.9368 6.64664C20.0263 6.64664 18.5952 8.03158 18.5952 10.3824C18.5952 12.7297 20.0263 14.1182 21.9368 14.1182C23.8438 14.1182 25.2784 12.7333 25.2784 10.3824ZM23.9538 10.3824C23.9538 12.0373 23.1229 12.9357 21.9368 12.9357C20.7543 12.9357 19.9197 12.0373 19.9197 10.3824C19.9197 8.72761 20.7543 7.82917 21.9368 7.82917C23.1229 7.82917 23.9538 8.72761 23.9538 10.3824ZM30.4764 8.74536H31.7441C31.7193 7.51667 30.6717 6.64664 29.1234 6.64664C27.5964 6.64664 26.4494 7.50601 26.4529 8.79153C26.4529 9.83556 27.1951 10.4357 28.3919 10.7447L29.2193 10.9577C30.0041 11.1566 30.5225 11.4016 30.5261 11.9662C30.5225 12.5877 29.9331 13.0032 29.0737 13.0032C28.2498 13.0032 27.6106 12.6339 27.5574 11.8704H26.2612C26.3145 13.3157 27.3904 14.1289 29.0843 14.1289C30.8279 14.1289 31.84 13.2589 31.8436 11.9769C31.84 10.7162 30.7995 10.141 29.7058 9.88172L29.024 9.71127C28.4274 9.56922 27.7811 9.31709 27.7882 8.70985C27.7917 8.16298 28.2818 7.7617 29.1056 7.7617C29.8904 7.7617 30.4089 8.12746 30.4764 8.74536ZM32.6985 7.85048H34.9464V14.0188H36.2532V7.85048H38.5011V6.74607H32.6985V7.85048ZM42.1001 14.0188H43.4176V11.5614H44.8097C46.4893 11.5614 47.3913 10.5529 47.3913 9.15374C47.3913 7.76525 46.5 6.74607 44.8274 6.74607H42.1001V14.0188ZM43.4176 10.4783V7.84692H44.625C45.6122 7.84692 46.049 8.37959 46.049 9.15374C46.049 9.92789 45.6122 10.4783 44.6321 10.4783H43.4176ZM55.0343 10.3824C55.0343 8.03158 53.5996 6.64664 51.6926 6.64664C49.7821 6.64664 48.351 8.03158 48.351 10.3824C48.351 12.7297 49.7821 14.1182 51.6926 14.1182C53.5996 14.1182 55.0343 12.7333 55.0343 10.3824ZM53.7097 10.3824C53.7097 12.0373 52.8787 12.9357 51.6926 12.9357C50.5101 12.9357 49.6756 12.0373 49.6756 10.3824C49.6756 8.72761 50.5101 7.82917 51.6926 7.82917C52.8787 7.82917 53.7097 8.72761 53.7097 10.3824ZM56.2798 14.0188H57.5973V11.5614H58.9893C60.669 11.5614 61.571 10.5529 61.571 9.15374C61.571 7.76525 60.6797 6.74607 59.0071 6.74607H56.2798V14.0188ZM57.5973 10.4783V7.84692H58.8047C59.7919 7.84692 60.2287 8.37959 60.2287 9.15374C60.2287 9.92789 59.7919 10.4783 58.8118 10.4783H57.5973ZM67.2999 6.74607V11.3874C67.2999 12.3 66.6642 12.9535 65.6664 12.9535C64.665 12.9535 64.0328 12.3 64.0328 11.3874V6.74607H62.7154V11.4975C62.7154 13.06 63.8873 14.1289 65.6664 14.1289C67.4384 14.1289 68.6174 13.06 68.6174 11.4975V6.74607H67.2999ZM70.0494 14.0188H74.57V12.9144H71.3668V6.74607H70.0494V14.0188ZM76.9208 14.0188L77.521 12.2255H80.2553L80.859 14.0188H82.2653L79.7013 6.74607H78.0749L75.5146 14.0188H76.9208ZM77.8761 11.1672L78.8597 8.23755H78.9165L79.9002 11.1672H77.8761ZM83.2232 14.0188H84.5407V11.3554H85.883L87.3105 14.0188H88.7807L87.2076 11.1353C88.0634 10.7908 88.5144 10.0593 88.5144 9.07207C88.5144 7.68357 87.6195 6.74607 85.9505 6.74607H83.2232V14.0188ZM84.5407 10.2617V7.84692H85.748C86.7317 7.84692 87.1721 8.29792 87.1721 9.07207C87.1721 9.84621 86.7317 10.2617 85.7551 10.2617H84.5407Z"
                        fill="url(#paint1_linear)"
                    />
                    <defs>
                        <linearGradient
                            id="paint0_linear"
                            gradientUnits="userSpaceOnUse"
                            x1="-2.10789e-07"
                            x2="111.55"
                            y1="10.0188"
                            y2="10.0188"
                        >
                            <stop stop-color="#EC6762" />
                            <stop offset="1" stop-color="#11A1FD" />
                        </linearGradient>
                        <linearGradient
                            id="paint1_linear"
                            gradientUnits="userSpaceOnUse"
                            x1="-6.1875"
                            x2="128.813"
                            y1="10.0188"
                            y2="10.0188"
                        >
                            <stop stop-color="#EB6864" />
                            <stop offset="1" stop-color="#3399E6" />
                        </linearGradient>
                    </defs>
                </svg>
                <svg
                    v-if="subscriptionPlan.cta_sticker === 'best_value'"
                    class="m-auto"
                    fill="none"
                    height="20"
                    viewBox="0 0 78 20"
                    width="78"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect
                        fill="white"
                        height="16.1656"
                        rx="3"
                        stroke="url(#paint0_linear)"
                        stroke-width="2"
                        width="76"
                        x="1"
                        y="1.93604"
                    />
                    <path
                        d="M9.71733 14.0188H12.6612C14.3267 14.0188 15.1435 13.1701 15.1435 12.0373C15.1435 10.9364 14.3622 10.2901 13.5881 10.251V10.18C14.2983 10.0131 14.8594 9.51596 14.8594 8.63173C14.8594 7.54863 14.0781 6.74607 12.5014 6.74607H9.71733V14.0188ZM11.0348 12.9179V10.7873H12.4872C13.3004 10.7873 13.8047 11.2844 13.8047 11.9343C13.8047 12.5131 13.407 12.9179 12.4517 12.9179H11.0348ZM11.0348 9.83911V7.83272H12.3665C13.1406 7.83272 13.5419 8.2411 13.5419 8.80218C13.5419 9.44138 13.0234 9.83911 12.3381 9.83911H11.0348ZM16.2896 14.0188H21.0481V12.9144H17.6071V10.9293H20.7747V9.82491H17.6071V7.85048H21.0197V6.74607H16.2896V14.0188ZM26.3162 8.74536H27.584C27.5591 7.51667 26.5115 6.64664 24.9632 6.64664C23.4363 6.64664 22.2892 7.50601 22.2928 8.79153C22.2928 9.83556 23.035 10.4357 24.2317 10.7447L25.0591 10.9577C25.8439 11.1566 26.3624 11.4016 26.3659 11.9662C26.3624 12.5877 25.7729 13.0032 24.9135 13.0032C24.0897 13.0032 23.4505 12.6339 23.3972 11.8704H22.101C22.1543 13.3157 23.2303 14.1289 24.9242 14.1289C26.6678 14.1289 27.6799 13.2589 27.6834 11.9769C27.6799 10.7162 26.6394 10.141 25.5456 9.88172L24.8638 9.71127C24.2672 9.56922 23.6209 9.31709 23.628 8.70985C23.6316 8.16298 24.1216 7.7617 24.9455 7.7617C25.7303 7.7617 26.2488 8.12746 26.3162 8.74536ZM28.5384 7.85048H30.7862V14.0188H32.093V7.85048H34.3409V6.74607H28.5384V7.85048ZM38.913 6.74607H37.4677L40.0281 14.0188H41.6545L44.2184 6.74607H42.7695L40.8803 12.4705H40.8058L38.913 6.74607ZM45.2607 14.0188L45.8608 12.2255H48.5952L49.1989 14.0188H50.6051L48.0412 6.74607H46.4148L43.8544 14.0188H45.2607ZM46.2159 11.1672L47.1996 8.23755H47.2564L48.2401 11.1672H46.2159ZM51.563 14.0188H56.0836V12.9144H52.8805V6.74607H51.563V14.0188ZM61.8116 6.74607V11.3874C61.8116 12.3 61.176 12.9535 60.1781 12.9535C59.1767 12.9535 58.5446 12.3 58.5446 11.3874V6.74607H57.2271V11.4975C57.2271 13.06 58.399 14.1289 60.1781 14.1289C61.9501 14.1289 63.1291 13.06 63.1291 11.4975V6.74607H61.8116ZM64.5611 14.0188H69.3196V12.9144H65.8786V10.9293H69.0462V9.82491H65.8786V7.85048H69.2912V6.74607H64.5611V14.0188Z"
                        fill="url(#paint1_linear)"
                    />
                    <defs>
                        <linearGradient
                            id="paint0_linear"
                            gradientUnits="userSpaceOnUse"
                            x1="-1.69501e-07"
                            x2="89.7"
                            y1="10.0188"
                            y2="10.0188"
                        >
                            <stop stop-color="#EC6762" />
                            <stop offset="1" stop-color="#11A1FD" />
                        </linearGradient>
                        <linearGradient
                            id="paint1_linear"
                            gradientUnits="userSpaceOnUse"
                            x1="-2.4375"
                            x2="99.2292"
                            y1="10.0188"
                            y2="10.0188"
                        >
                            <stop stop-color="#EB6864" />
                            <stop offset="1" stop-color="#3399E6" />
                        </linearGradient>
                    </defs>
                </svg>
            </div>

            <ul class="flex-none p-8">
                <li
                    v-for="feature in subscriptionPlan.features"
                    :class="
                        'mb-2 flex items-start text-[14px] ' +
                        feature.display_css
                    "
                >
                    <i
                        v-if="feature.icon"
                        :class="
                            'relative top-1 mr-2 text-[18px] text-success-default ' +
                            feature.icon
                        "
                    ></i>
                    {{ feature.text }}
                </li>
            </ul>

            <div class="flex-grow"></div>

            <div
                class="flex-none border-b border-t border-neutral-10 p-4 text-center text-[14px] font-semibold text-neutral-80"
            >
                <div v-if="subscriptionPlan.renews">
                    <span class="font-normal text-neutral-60"
                        >Access renews</span
                    >
                    {{ endsAt }}
                </div>
                <div v-else>
                    <span class="font-normal text-neutral-60">Access ends</span>
                    {{ endsAt }}
                </div>
            </div>

            <div class="flex-none text-center">
                <span
                    v-if="isSelected === true"
                    :dusk="'choose-plan-' + subscriptionPlan.id"
                    class="btn btn-secondary btn-sm my-4 inline-block"
                >
                    Selected
                </span>
                <span
                    v-else
                    :dusk="'choose-plan-' + subscriptionPlan.id"
                    class="btn btn-primary btn-sm my-4 inline-block"
                    @click="selectPlan(subscriptionPlan)"
                >
                    {{ buttonLabel }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import ValueAsCurrency from "@/Components/ValueAsCurrency";
import dayjs from "dayjs";

export default {
    name: "SubscriptionPriceBox",
    components: { ValueAsCurrency },
    props: {
        subscriptionPlan: {
            type: Object,
            default: {},
        },
        action: {
            type: String,
            default: "redirect",
        },
        buttonLabel: {
            type: String,
            default: "Choose This Plan",
        },
        isSelected: {
            type: Boolean,
        },
    },
    methods: {
        selectPlan(subscriptionPlan) {
            if (this.action === "redirect") {
                window.location.href =
                    "/register?plan_id=" + subscriptionPlan.id;
            } else {
                this.$emit("selected", subscriptionPlan);
            }
        },
    },
    computed: {
        endsAt() {
            let endsAt = null;
            let unit = "D";

            if (this.subscriptionPlan.period_label === "months") {
                unit = "M";
            }

            if (this.subscriptionPlan.period_label === "years") {
                unit = "Y";
            }

            endsAt = dayjs()
                .utc(true)
                .tz(this.$page.props.display_timezone)
                .add(this.subscriptionPlan.length, unit)
                .format("M/D/YYYY");

            return endsAt;
        },
    },
};
</script>

<style scoped></style>
